// @ts-nocheck
// oxlint-disable no-unused-vars
import type { ApiResponseOfImageUploadDto, IFormFile } from "../types";
import { apiFetch, type ApiResponse } from "@/api/fetch";

/** Auto-generated file. Do not edit. */

/**
 * POST `/files/images`
 */
export const postApiFilesImages = (data: { file: IFormFile }) =>
	apiFetch<ApiResponseOfImageUploadDto>({
		uri: "files/images",
		method: "POST",
		body: data,
	});
